import { Pipe, PipeTransform } from '@angular/core';
import { Owner } from '@queries/generated';
import { SelectItem } from 'primeng/api';

@Pipe({
  name: 'ownersToOptions'
})
export class OwnersToOptionsPipe implements PipeTransform {
  transform(values: Pick<Owner, 'name' | 'gid'>[], gid = true): SelectItem[] {
    if (values) {
      return values.map((owner) => ({
        label: owner.name,
        value: gid ? owner.gid : owner
      }));
    }
    return [];
  }
}
